export default __webpack_public_path__ + "static/media/timbertech-ca.5639085f.csv";